import React from 'react';
import Checkbox from '../../../components/Checkbox';
import TableCell from '../../../components/TableCell';
import ElementStatusV2StatusCell from './ElementStatusV2StatusCell';
import { ELEMENT_TYPES, MAIN_STATUS_CATEGORIES } from '../../../constants';

const stickyColumnWidths = [40, 340, 170, 40];
const stickyCellBaseStyle = {
  backgroundColor: '#fff',
  padding: 0,
  position: 'sticky',
  zIndex: 2,
};

const getStickyCellStyle = (index) => {
  if (index === 0) {
    return { ...stickyCellBaseStyle, left: 0 };
  }

  if (index === 1) {
    return { ...stickyCellBaseStyle, left: stickyColumnWidths[0] };
  }

  if (index === 2) {
    return {
      ...stickyCellBaseStyle,
      left: stickyColumnWidths[0] + stickyColumnWidths[1],
    };
  }

  if (index === 3) {
    return {
      ...stickyCellBaseStyle,
      left:
        stickyColumnWidths[0] + stickyColumnWidths[1] + stickyColumnWidths[2],
    };
  }

  return undefined;
};

const columnWidths = [40, 340, 170, 40, 170, 170, 250, 170, 300, 300, 300];
const fillCellStyle = { height: '40px', minHeight: '40px', width: '100%' };

const getCellHighlightColor = (row) => {
  if (row.raw.elementType === ELEMENT_TYPES.CRITICAL) {
    if (row.status.startsWith(MAIN_STATUS_CATEGORIES.VALID_COMPLETION)) {
      return 'grey';
    }
    return 'red';
  }
  return '';
};

const getCellClassName = (index) =>
  index <= 3
    ? 'status-table__table-cell status-table__table-cell--sticky'
    : 'status-table__table-cell';

export default function ElementStatusV2Row({
  onOpenElementContent = () => {},
  onOpenDetails = () => {},
  onOpenHistory = () => {},
  onRefreshRow = () => {},
  row,
  selectedRows = {},
  toggleRowSelection = () => {},
}) {
  const isSelected = (selectedRows[row.personId] || []).includes(row.elementId);

  return (
    <>
      <td
        className={getCellClassName(0)}
        data-testid={`selection-cell-${row.id}`}
        style={{ ...getStickyCellStyle(0), width: columnWidths[0] }}
      >
        <TableCell centerContent style={fillCellStyle}>
          <Checkbox
            id={`select-row-${row.id}`}
            isChecked={isSelected}
            onChange={() => toggleRowSelection(row.personId, row.elementId)}
          />
        </TableCell>
      </td>
      <td
        className={getCellClassName(1)}
        style={{ ...getStickyCellStyle(1), width: columnWidths[1] }}
      >
        <TableCell
          icon={row.elementIcon}
          onIconClick={
            row.elementIcon ? () => onOpenElementContent(row) : undefined
          }
          title={row.elementName}
          highlightColor={getCellHighlightColor(row)}
        />
      </td>
      <td
        className={getCellClassName(2)}
        style={{ ...getStickyCellStyle(2), width: columnWidths[2] }}
      >
        <TableCell
          subtitle={row.personSubtitle}
          title={row.personName}
          tooltip={row.personTooltip}
        />
      </td>
      <td
        className={getCellClassName(3)}
        data-testid={`status-cell-${row.id}`}
        style={{ ...getStickyCellStyle(3), width: columnWidths[3] }}
      >
        <TableCell style={fillCellStyle}>
          <ElementStatusV2StatusCell
            onOpenDetails={onOpenDetails}
            onOpenHistory={onOpenHistory}
            onRefreshRow={onRefreshRow}
            row={row}
          />
        </TableCell>
      </td>
      <td
        className={getCellClassName(4)}
        style={{ padding: 0, width: columnWidths[4] }}
      >
        <TableCell
          subtitle={row.responsibleSubtitle}
          subtitleTooltip={row.responsibleSubtitleTooltip}
          title={row.responsible}
          titleColor={row.responsibleTitleColor}
          tooltip={row.responsibleTooltip}
        />
      </td>
      <td
        className={getCellClassName(5)}
        style={{ padding: 0, width: columnWidths[5] }}
      >
        <TableCell
          title={row.mentor}
          titleColor={row.mentorTitleColor}
          tooltip={row.mentorTooltip}
        />
      </td>
      <td
        className={getCellClassName(6)}
        style={{ padding: 0, width: columnWidths[6] }}
      >
        <TableCell
          icon={row.hasHistory ? 'calendar-check' : null}
          onIconClick={row.hasHistory ? () => onOpenHistory(row) : undefined}
          subtitle={row.latestActivitySubtitle}
          subtitleTooltip={row.latestActivitySubtitleTooltip}
          title={row.latestActivity}
        />
      </td>
      <td
        className={getCellClassName(7)}
        style={{ padding: 0, width: columnWidths[7] }}
      >
        <TableCell title={row.expirationDate} />
      </td>
      <td
        className={getCellClassName(8)}
        style={{ padding: 0, width: columnWidths[8] }}
      >
        <TableCell
          title={row.organisationUnit}
          tooltip={row.organisationUnitTooltip}
        />
      </td>
      <td
        className={getCellClassName(9)}
        style={{ padding: 0, width: columnWidths[9] }}
      >
        <TableCell title={row.role} tooltip={row.roleTooltip} />
      </td>
      <td
        className={getCellClassName(10)}
        style={{ padding: 0, width: columnWidths[10] }}
      >
        <TableCell title={row.module} />
      </td>
    </>
  );
}
